import styled from 'styled-components';

import { ModalContent } from '../../styles';

const StyledModalContent = styled(ModalContent)`
  padding-top: 10px;
`;

export {
  StyledModalContent,
};
